
    import { useContext, useEffect, useRef, useState }  from 'react'
    import GlobalContext from 'proj/contexts/global';
    import ClassNames from 'classnames';

    import * as Recommended from './components';

    import * as IO from 'js/core/io';

    const EMAIL_REGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const SUBSCRIBE_QA_ENDPOINT = `https://audience.qa.cnn.com/newsletters/api/1/subscriptions/add`;
    const SUBSCRIBE_ENDPOINT = `https://audience.cnn.com/newsletters/api/1/subscriptions/add`;

    const SUBSCRIPTION_OBJ = {
        "email": null,
        "newsletters": [],
        "userProfileRequest": {
            "attributes": {
                "newsletters": {
                }
            }
        },
        "emailAddress": null
    }

    let email_store = null;

    export default ( { ...props } ) =>
    {
        const { active, data, store } = useContext(GlobalContext);
        
        const { endpoints, newsletters, url } = data;
        const { title, description, success_message, 
            module, email_text, invalid_email, cta, skip,
            failed_message, failed_cta, failed_skip, ...select } = data?.sections[active] || {};
        
        
        const [recommended, setRecommended] = useState(null);
        const [error, setError] = useState(null);
        const [items, setItems] = useState([]);

        const [success, setSuccess] = useState(null);

        const emailRef = useRef(null);
        
        // --------------------
        //  Events
        // --------------------

        const onFormSubmit = e =>
        {
            e.preventDefault();
            const email_address = validateEmail(emailRef.current?.value);

            if(email_address)
            {
                email_store = email_address;
                subscribeToNewsletters(email_address);
            }
        }

        const onPostSuccess = (p_data) =>
        {
            const response = JSON.parse(p_data.currentTarget?.responseText);

            if(response.errors)
            {
                setSuccess(false);
            }
            else
            {
                // console.log(response);
                setSuccess(true);
            }
        }

        const onPostError = (p_err) =>
        {
            setSuccess(false);
        }

        // --------------------
        //  Methods
        // --------------------

        const validateEmail = (p_email) =>
        {
            const err = !EMAIL_REGEX.test( p_email )
                ? ({ message: invalid_email })
                : null;
            
            setError(err);

            return err ? null : p_email;
        }

        const insertValues = (p_txt) =>
        {
            if(!recommended) return "";

            const newsletter = newsletters[recommended?.newsletter_id];

            p_txt = p_txt.split("{Section}").join(recommended?.title);
            p_txt = p_txt.split("{section}").join(recommended?.title?.toLowerCase());
            p_txt = p_txt.split("{SECTION}").join(recommended?.title?.toUpperCase());
            p_txt = p_txt.split("{newsletter_name}").join(`${newsletter?.name}`);
            return p_txt;
        }

        const subscribeToNewsletters = (email_address) =>
        {
            if(!email_address) return;

            const post_obj = { ...SUBSCRIPTION_OBJ };
            
            const newsletter_arr = [];
            const newsletter_obj = {};
            const current_time = new Date();
            const countryCode = WM?.UserConsent ?  WM.UserConsent.getGeoCountry() : "";

            const recommended_newsletter = newsletters[recommended?.newsletter_id || "life_but_better"];
            const default_newsletter = newsletters["life_but_better"];

            // Add data to payload
            if( recommended_newsletter.id != default_newsletter.id )
            {
                newsletter_arr.push(recommended_newsletter.id);
                newsletter_obj[`${recommended_newsletter.id}_source`] = recommended_newsletter.source;
                newsletter_obj[`${recommended_newsletter.id}_subscribe`] = current_time;
            }

            newsletter_arr.push(default_newsletter.id);
            newsletter_obj[`${default_newsletter.id}_source`] = default_newsletter.source;
            newsletter_obj[`${default_newsletter.id}_subscribe`] = current_time;
            
            if(countryCode) newsletter_obj.acquisition_country = countryCode;

            // Set values to main payload obj;
            post_obj.email = post_obj.emailAddress = email_address;
            post_obj.userProfileRequest.attributes.newsletters = newsletter_obj;
            post_obj.newsletters = newsletter_arr;

            // Submit payload
            console.log(post_obj);

            IO.Post(SUBSCRIBE_ENDPOINT,
                {
                    data: post_obj,
                    success: onPostSuccess,
                    error: onPostError
                } , true);
        }
        

        // --------------------
        //  useEffect
        // --------------------

        useEffect(() =>
        {
            if(module?.store) setItems(store[module.store]);
        }, []);

        useEffect(() =>
        {
            if(items.length > 0)
            {
                const defaultEndpoint = endpoints.find(val => val.default != undefined) || endpoints[0];
                const itemEndpoints = items.map(val => endpoints.find(v => v.keywords.indexOf(val.value) != -1)).filter(Boolean);
                const recommendedEndpoint = itemEndpoints.length > 0 && itemEndpoints.find(val => val.newsletter_id != undefined) || defaultEndpoint;
                setRecommended(recommendedEndpoint || defaultEndpoint);
            }
        }, [items]);

        useEffect(() =>
        {
            if(success == true)
            {
                setTimeout(() =>
                {
                    window.location = recommended.url ? `${DOMAIN}${recommended.url}` : url;
                }, 5000);
            }
        }, [success]);

        // --------------------
        //  Build
        // --------------------

        const getSignup = () =>
            <Recommended.Content className={ ClassNames(module?.class, {error}) }>
                { title && <Recommended.Title text={ insertValues(title) } /> }
                <Recommended.Logo src={ recommended.img?.value?.src } />
                { description && <Recommended.Description text={ insertValues( recommended.pitch_text || description) } />}
                <Recommended.Form onSubmit={ onFormSubmit }>
                    <Recommended.EmailInput ref={ emailRef } placeholder={ email_text || "Enter your email address" } />
                    { error && <Recommended.Error text={ insertValues( error.message ) }/> }
                    <Recommended.Submit type="submit" value={ insertValues(cta) || "Sign up" }/>
                </Recommended.Form>
                { skip && <Recommended.Skip text={insertValues(skip)} href={ recommended.url ? `${DOMAIN}${recommended.url}` : url } />}
            </Recommended.Content>

        const getSuccess = () =>
            <Recommended.Content className={ ClassNames(module?.class) }>
                <Recommended.Logo src={ recommended.img?.value?.src } />
                { success_message && <Recommended.Description text={ insertValues(success_message) } />}
            </Recommended.Content>

        const getFailed = () =>
            <Recommended.Content className={ ClassNames(module?.class) }>
                <Recommended.Logo src={ recommended.img?.value?.src } />
                { success_message && <Recommended.Description text={ insertValues(failed_message) } />}
                
                <Recommended.Form onSubmit={ onFormSubmit }>
                    <Recommended.EmailInput ref={ emailRef } defaultValue={ email_store } placeholder={ email_text || "Enter your email address" } />
                    <Recommended.Submit type="submit" value={ insertValues(failed_cta) || "Sign up" }/>
                </Recommended.Form>

                { failed_skip && <Recommended.Skip text={insertValues(failed_skip)} href={ recommended.url ? `${DOMAIN}${recommended.url}` : url } />}

            </Recommended.Content>

        return recommended && ( success == null ? getSignup() : success == true ? getSuccess() : getFailed() );
    }